export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7ff373b03fba7cb27c8c2797c2864e154045dff2ed&name=fetchTypeahead!'